import * as React from 'react';

import { throttle } from 'throttle-debounce';

import { isMobileScreen } from '@base/utils';

interface IUsePreventScroll {
	isDisableScroll: boolean;
}

export function usePreventScroll({ isDisableScroll }: IUsePreventScroll) {
	function disableScroll() {
		if (!IS_SSR) {
			document.documentElement.style.overflow = 'hidden';
		}
	}

	function enableScroll() {
		if (!IS_SSR) {
			document.documentElement.style.overflow = '';
		}
	}

	const onResize = throttle(1000, () => {
		if (!isMobileScreen()) {
			enableScroll();
		}
	});

	React.useEffect(() => {
		if (isDisableScroll) {
			disableScroll();
		} else {
			enableScroll();
		}
	}, [isDisableScroll]);

	React.useEffect(() => {
		window.addEventListener('resize', onResize);

		return () => {
			window.removeEventListener('resize', onResize);
		};
	}, []);
}
